import React, {Component} from 'react'
import {
    Form,
    Input,
    Row,
    Col,
    Select,
    DatePicker,
    Button,
    Table, message,
} from 'antd';
import {baseUrl, reqTrackList, getCreateDeclareFile} from '../../api'
import LinkButton from '../../components/link-button'
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthLinkButton = authorizeBase(LinkButton)

moment.locale('zh-cn');
const {Option} = Select;
const DOWNLOAD_PATH = baseUrl.replace('/mms', '/upload')
const orderStatus = {
    audit: '待审核',
    audited: '待订舱',
    booked: '已订舱',
    boxed: '已装箱',
    declare: '待报关',
    declaring: '报关中',
    released: '已放行',
    cancelled: '已取消'
};
const logisticsStatus = {
    waiting: "待提货",
    transport: '运输中',
    boxed: '已装箱',
    declaring: '报关中',
    released: '已放行',
    destination: '已到达',
    cancelled: '已取消'
};
const status={
    "new":"新建",
    "uploading":"上传中",
    "success":"上传成功",
    "failed":"上传失败",
    "creating":"生成中",
    "created":"已生成",
}
class DocList extends Component {

    state = {
        total: 0, // 商品的总数量
        orderList: [], // 商品的数组
        pageNum: 1,
        searchData: {},
        deliveryFromDt: null,
        deliveryToDt: null,
        importList: [],
        sortData: {}
    }

    getProducts = async (pageNum, sortData) => {
        const pageSize = 10
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        })
        const {getFieldsValue} = this.props.form
        const values = getFieldsValue();
        const {deliveryFromDt, deliveryToDt} = this.state
        values.deliveryFromDt = deliveryFromDt;
        values.deliveryToDt = deliveryToDt;
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        if (sortData) {
            values.sort = sortData.sort
            values.order = sortData.order
        }
        if (!values.orderStatus) {
            values.notInStatusStr = 'audit';
        }
        let result = await reqTrackList(values)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    componentDidMount() {
        this.getProducts(1)
    }

    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.pageNum = 1
            values.pageSize = 10;
            this.setState({
                pageNum:values.pageNum
            })
            const {deliveryFromDt, deliveryToDt, sortData} = this.state
            values.deliveryFromDt = deliveryFromDt;
            values.deliveryToDt = deliveryToDt;
            if (sortData) {
                values.sort = sortData.sort
                values.order = sortData.order
            }
            if (!values.orderStatus) {
                values.notInStatusStr = 'audit';
            }
            if (!err) {
                this.reqTrackList(values);
            }
        });
    };

    reqTrackList = async (po) => {
        const result = await reqTrackList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else {
            message.error(result.message);
        }
    };

    // 日期选择
    onDateChange = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryFromDt: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryToDt: dateString
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        const sortData = {
            sort: sorter.field,
            order: sorter.order,
        }
        this.setState({
            sortData
        })
        this.getProducts(pageNum, sortData)
    };

    createFile = async (orderId) => {
        const result = await getCreateDeclareFile({orderId});
        if (result.code === 200) {
            this.getProducts(this.state.pageNum)
            message.info(result.message);
        } else {
            message.error(result.message);
        }

    }

    render() {

        const form = this.props.form
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 9},
                sm: {span: 9},
            },
            wrapperCol: {
                xs: {span: 13},
                sm: {span: 13},
            },
        }
        // 取出状态数据
        const {orderList, total} = this.state
        const columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                width: '12%',
                sorter: true,
                render: (text, record) => (
                    <a onClick={() => this.props.history.push('/orderInfoView', {orderId: record.id})}>{text}</a>
                )
            },
            {
                title: '揽收单位',
                dataIndex: 'entName',
            },
            {
                title: '起运地',
                sorter: true,
                dataIndex: 'originCity',
                width: '12%',
                render: (text, record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            }, {
                title: '转关地',
                sorter: true,
                dataIndex: 'destinationStartCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationStartCountry}&nbsp;{record.destinationStartCity}
                  </span>
                )
            },{
                title: '目的地',
                width: '12%',
                sorter: true,
                dataIndex: 'destinationCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            }, {
                title: '订单状态',
                width: '8%',
                sorter: true,
                dataIndex: 'orderStatus',
                render: (text, record) => (
                    <span>
                        {orderStatus[text]}
                    </span>
                )
            }, {
                title: '物流状态',
                width: '8%',
                sorter: true,
                dataIndex: 'logisticsStatus',
                render: (text, record) => (
                    <span>
                        {logisticsStatus[text]}
                    </span>
                )
            }, {
                title: '提货时间',
                sorter: true,
                dataIndex: 'deliveryTime',
                width: '15%',
            }, {
                title: '状态',
                dataIndex: 'importStatus',
                width: '8%',
                render: (text, record) => (
                    <span>
                        {status[text]}
                    </span>
                )
            }, {
                title: '操作',
                dataIndex: 'opt',
                width: '12%',
                render: (text, record) => {
                    if(record.orderStatus=='cancelled'){
                        return null
                    }else{
                        return <span>
                        <AuthLinkButton authority="order:export"
                                        onClick={() => this.createFile(record.id)}>生成</AuthLinkButton>
                        {record.declareFileLocation && record.declareFileLocation != null ?
                            <a href={DOWNLOAD_PATH + record.declareFileLocation}>报关文件</a> : ''}
                    </span>
                        
                    }
                    
                }
            }
        ];
        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>订单列表</div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={6}>
                            <Form.Item label="订单编号">
                                {getFieldDecorator('orderNo', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="起运地">
                                {getFieldDecorator('departure', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="目的地">
                                {getFieldDecorator('destination', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="品名(中文)">
                                {getFieldDecorator('goodName', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="订单状态">
                                {getFieldDecorator('orderStatus', {
                                    initialValue: '',
                                })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    <Option value="">全部</Option>
                                    {/*<Option value="audited">待订舱</Option>*/}
                                    <Option value="booked">已订舱</Option>
                                    <Option value="boxed">已装箱</Option>
                                    <Option value="declare">待报关</Option>
                                    <Option value="declaring">报关中</Option>
                                    <Option value="released">已放行</Option>
                                    <Option value="cancelled">已取消</Option>
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="物流状态">
                                {getFieldDecorator('logisticsStatus', {
                                    initialValue: '',
                                })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    <Option value="">全部</Option>
                                    <Option value="waiting">待提货</Option>
                                    <Option value="boxed">已装箱</Option>
                                    <Option value="transport">运输中</Option>
                                    <Option value="declaring">报关中</Option>
                                    <Option value="released">已放行</Option>
                                    <Option value="destination">已到达</Option>
                                    <Option value="cancelled">已取消</Option>
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="提货时间" className='time-input-to'>
                                {getFieldDecorator('deliveryFromDt')(<DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={this.onDateChange} style={{width: "100%", minWidth: 10}}
                                />)}

                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label={"至"} className='time-input-to'>
                                {getFieldDecorator('deliveryToDt')(<DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={this.onDateChange2} style={{width: "100%", minWidth: 10}}
                                />)}
                            </Form.Item>
                        </Col>
                        <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                            <Button type='primary' htmlType="submit"
                                    style={{float: 'right', marginRight: '16.7%'}}>查询</Button>
                        </Col>
                    </Row>
                </Form>

                <Table
                    columns={columns}
                    bordered
                    dataSource={orderList}
                    rowKey='id'
                    scroll={{x: 1500}}
                    onChange={this.handleTableChange}
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true
                    }}
                    size="middle"
                />
            </div>

        )
    }
}
const DocListForm = Form.create()(DocList)
export default DocListForm